/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Storage_UsageInputs */

const en_ui_data_storage_usage = /** @type {(inputs: Ui_Data_Storage_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storage`)
};

const de_ui_data_storage_usage = /** @type {(inputs: Ui_Data_Storage_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicher`)
};

/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Ui_Data_Storage_UsageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_storage_usage = /** @type {((inputs?: Ui_Data_Storage_UsageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Storage_UsageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_storage_usage(inputs)
	return de_ui_data_storage_usage(inputs)
});